import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { RecruitmentService } from '../../../service/recruitment/recruitment.service';
import { Recruitment } from '../../../class/recruitment';
import { ActivatedRoute } from '@angular/router';
import { CitationService } from '../../../service/citation/citation.service';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Candidate} from '../../../class/candidate';
import { Location } from '@angular/common';
//import { HeroService } from '../hero.service';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-recruitments-by-requisition',
  templateUrl: './recruitments-by-requisition.component.html',
  styleUrls: ['./recruitments-by-requisition.component.scss']
})
export class RecruitmentsByRequisitionComponent implements OnInit, OnChanges {

  @Input() params_id_requisition: number;
    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public recruitments: Recruitment[];
    public selectRecruitment: Recruitment;
    public recruitmentID: Number = 0;
    public modNew = false;
    public modView = false;
    public totalRecords: number;
    public page: number;
    public first = 0;
    public per_page: number;
    public sort: string;
    public query: string;
    public loading: boolean;
    public filters: any[];
    public reloadInterval: any;
    public es: any;

    public form3: FormGroup;
    public candidate_id_filter: AbstractControl;
    public recruited_by_id_filter: AbstractControl;
    // public company_id_filter: AbstractControl;
    public start_recruited_accepted_filter: AbstractControl;
    public end_recruited_accepted_filter: AbstractControl;
    public employeePositionToLoadRecruitment: string;

    public form5: FormGroup;
    public selectCandidate: Candidate;
    public mobile_send: AbstractControl;
    public message_send: AbstractControl;
    public modViewDialogWhatsapp: boolean;
    public sticky: boolean;
    public id_requisition: number=0;

    public modViewDialogCandidate: boolean;

    constructor(
        public recruitmentService: RecruitmentService,
        public confirmationService: ConfirmationService,
        public activatedRoute: ActivatedRoute,
        public fb: FormBuilder,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        private location: Location) {

            this.es = calendarES();

            this.employeePositionToLoadRecruitment = '1,5,6,21,38';
            this.loading = false;

            this.form3 = fb.group({
                'candidate_id_filter': [''],
                'recruited_by_id_filter': [''],
                // 'company_id_filter': [''],
                'start_recruited_accepted_filter': [''],
                'end_recruited_accepted_filter': [''],
            });
            this.candidate_id_filter = this.form3.controls['candidate_id_filter'];
            this.recruited_by_id_filter = this.form3.controls['recruited_by_id_filter'];
            // this.company_id_filter = this.form3.controls['company_id_filter'];
            this.start_recruited_accepted_filter = this.form3.controls['start_recruited_accepted_filter'];
            this.end_recruited_accepted_filter = this.form3.controls['end_recruited_accepted_filter'];
            this.form5 = fb.group({
                'mobile_send': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
                'message_send': ['', Validators.compose([Validators.required, Validators.minLength(2)])]
            });
            this.mobile_send = this.form5.controls['mobile_send'];
            this.message_send = this.form5.controls['message_send'];
            this.modViewDialogWhatsapp = false;
        }

    ngOnInit() {
        this.filters = [];

        this.page = 1;
        this.per_page = 10;
        this.sort = '-citations.id';
        // this.filters.push({'key': 'recruited-in', 'value': '1'});
        var id = Number(this.activatedRoute.snapshot.paramMap.get('id'));
        if(!isNaN(id))
            this.id_requisition = id;
        // this.getHero();
        // this.activatedRoute.queryParams.subscribe(params => {
        //     if (params['id_requisition']) {
        //         this.params_id_requisition = Number(params['id_requisition']);
        //     }
        // });

    }

      
    ngOnChanges() {
        this.filters = [];

        this.page = 1;
        this.per_page = 10;
        this.sort = '-citations.id';
        // this.filters.push({'key': 'recruited-in', 'value': '1'});

    }

    ngOnDestroy() {
        // Will clear when component is destroyed e.g. route is navigated away from.
        clearInterval(this.reloadInterval);
    }

    public loadRecruitmentsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort = '-' + event.sortField;
        } else {
            this.sort = event.sortField;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }
        this.sort = '-citations.id';
        this.filter();
        console.log("Es el recruiment load lazy");
    }

    public getRecruitments() {
        this.loading = true;
        this.recruitmentService.getRecruitment(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.loading = false;
                this.recruitments = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.loading = false;
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getRecruitmentsByRequisitions(id: number) {
        this.loading = true;
        this.recruitmentService.getRecruitmentByRequisition(id, this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.loading = false;
                this.recruitments = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.loading = false;
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newRecruitment() {
        this.modNew = !this.modNew;
        this.selectRecruitment = null;
    }

    public savedRecruitment(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectRecruitment = null;
        this.modNew = false;
        // this.getRecruitments();
        // this.getRecruitmentsByRequisitions(this.id_requisition);
    }

    public cancelRecruitment (res) {
        this.selectRecruitment = null;
        this.modNew = false;
        this.modView = false;
        // if (this.id_requisition) {
        //     this.getRecruitmentsByRequisitions(this.id_requisition);
        // } 
        // else {
        //     this.getRecruitments();
        // }
    }

    public edit(recruitment: Recruitment) {
        this.modNew = true;
        this.selectRecruitment = recruitment;
        // this.getRecruitments();
    }

    public deleteDialog(recruitment: Recruitment) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(recruitment);
            }
        });
    }

    public delete(recruitment: Recruitment) {
        this.recruitmentService.deleteRecruitment(recruitment.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                // this.getRecruitments();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public filterRefresh () {
        this.filter(true);
    }
    public viewDialogCandidate(candidate: Candidate, sticky: boolean) {
        this.selectCandidate = candidate;
        this.modViewDialogCandidate = true;
        this.sticky = sticky;
    }
    public viewDialogWhatsapp(candidate: Candidate, sticky: boolean) {
        this.selectCandidate = candidate;
        this.mobile_send.setValue(this.selectCandidate.mobile);
        this.message_send.setValue("Hola estimado(a) "+this.selectCandidate.name);
        this.modViewDialogWhatsapp = true;
        this.sticky = sticky;
    }
    public cancelViewDialogWhatsapp (res) {
        this.selectCandidate = null;
        this.modViewDialogWhatsapp = false;
    }
    openWhatsapp(event) {
        window.open('https://api.whatsapp.com/send?phone=' + '57' + event.mobile_send + '&text=' + event.message_send, '_blank');
    }
    public filter (pageRefresh?) {
        if (pageRefresh) {
            this.page = 1;
            this.first = 0;
        }

        this.filters = [];
        this.filters.push({'key': 'recruited-in', 'value': '1'});
        this.filters.push({'key': 'requisition-id', 'value': this.id_requisition});
        

        if (this.candidate_id_filter.value) {
            if (this.candidate_id_filter.value.id) {
                this.filters.push({'key': 'candidate_id-lk', 'value': this.candidate_id_filter.value.id});
            }
        }
        if (this.recruited_by_id_filter.value) {
            if (this.recruited_by_id_filter.value.id) {
                this.filters.push({'key': 'recruited_by_id-lk', 'value': this.recruited_by_id_filter.value.id});
            }
        }
        // if (this.company_id_filter.value) {
        //     if (this.company_id_filter.value.id) {
        //         this.filters.push({'key': 'company_id-lk', 'value': this.company_id_filter.value.id});
        //     }
        // }

        if (this.start_recruited_accepted_filter.value && this.end_recruited_accepted_filter.value) {
            let d = new Date(this.start_recruited_accepted_filter.value);
            d.setHours(0);
            d.setMinutes(0);
            d.setSeconds(0);
            d.setMilliseconds(0);

            const start_recruited_accepted_filter = formatDate(d);

            d = new Date(this.end_recruited_accepted_filter.value);
            d.setHours(23);
            d.setMinutes(59);
            d.setSeconds(59);
            d.setMilliseconds(59);
            const end_recruited_accepted_filter = formatDate(d);

            if (start_recruited_accepted_filter) {
                this.filters.push({'key': 'recruited_accepted_at-min=', 'value': start_recruited_accepted_filter});
            }

            if (end_recruited_accepted_filter) {
                this.filters.push({'key': 'recruited_accepted_at-max=', 'value': end_recruited_accepted_filter});
            }
        }

        if (this.id_requisition>0) {
            this.getRecruitmentsByRequisitions(this.id_requisition);
        } 
        // else {
        //     this.getRecruitments();
        // }
    }

    public activeRecruitment(recruitment: Recruitment) {
        this.putRecruitment(recruitment);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public recruitmentAccepted(recruitment: Recruitment, value?) {
        if (value === "0") {
            recruitment.recruited_accepted_at = null;
            recruitment.recruited_accepted_by_id = null;
        } else {
            recruitment.recruited_accepted_at = formatDate(new Date().toISOString());
        }
        recruitment.recruited_accepted = value;
        this.putRecruitment(recruitment);
    }

    public putRecruitment(values: Recruitment) {
        const param = {
            'recruited_accepted': values.recruited_accepted,
            'recruited_accepted_at': values.recruited_accepted_at,
            'recruited_accepted_by_id': values.recruited_accepted_by_id,        
        };
        if (values) {
            const promise = this.recruitmentService.updateRecruitment(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
        // this.getRecruitments();
    }

    cancelCandidate($event){
        this.selectCandidate = null;
        this.modNew = false;
        this.modView = false;
    }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/recruitment/recruitments-by-requisition/recruitments-by-requisition.component.ts